import React from 'react';

import styled from 'styled-components';

import Radio from 'components/lib/Radio';
import { COMPANY_STATUS } from 'constants/company';

import { useCommunityAdminContext } from './CommunityAdminContextProvider';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 420px;
`;

const Title = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
  margin-bottom: 12px;
`;

const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const StyledRadio = styled(Radio)`
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-right: 0;
`;

const CommunityAdminContentMysteryShopping = () => {
  const { includeInRegularShopCadence, selectedCompany, setIncludeInRegularShopCadence } = useCommunityAdminContext();
  const isPayingCompany = selectedCompany?.status === COMPANY_STATUS.PAYING_CUSTOMER;

  return (
    <Container>
      <Title>Mystery Shopping</Title>
      <StyledRadioGroup
        disabled={!isPayingCompany}
        value={includeInRegularShopCadence}
        onChange={(event: any) => setIncludeInRegularShopCadence(event.target.value)}
      >
        <StyledRadio value={true}>Include community in the regular shop cadence</StyledRadio>
        <StyledRadio value={false}>Do not include</StyledRadio>
      </StyledRadioGroup>
    </Container>
  );
};

export default CommunityAdminContentMysteryShopping;
